import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7ff4839c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "file-header"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "file-name"
};
const _hoisted_4 = {
  class: "preview-wrapper"
};
const _hoisted_5 = {
  class: "preview-box"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
import VideoPreview from './VideoPreview.vue';
import { VIDEOTYPES, AUDIOTYPES, PICTYPES } from '@/plugins/file-types';
export default {
  props: {
    show: Boolean,
    fileInfo: Object
  },
  emits: ["update:show"],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $utils = inject('$utils');
    const type = computed(() => {
      const suffix = props.fileInfo.suffix;

      if (PICTYPES.includes(suffix)) {
        return 'img';
      } else if (AUDIOTYPES.includes(suffix)) {
        return 'audio';
      } else if (VIDEOTYPES.includes(suffix)) {
        return 'video';
      }
    });

    const handleClose = () => {
      emit("update:show", false);
    };

    const setIframeHeight = (id = 'preview-iframe') => {
      const iframe = document.getElementById(id);

      if (iframe) {
        var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
        console.log(iframe);
        iframe.style.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
      }
    };

    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(show) ? show.value = $event : null),
        width: "800px",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
          src: require(`assets/images/types_icon/${_unref($utils).formatIcons(__props.fileInfo.suffix)}.png`),
          alt: "",
          class: "file-icon"
        }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.fileInfo.name), 1)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_unref(type) === 'img' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "img",
          src: __props.fileInfo.fileUrl,
          alt: ""
        }, null, 8, _hoisted_6)) : _unref(type) === 'audio' ? (_openBlock(), _createElementBlock("audio", {
          key: 1,
          src: __props.fileInfo.fileUrl,
          controls: ""
        }, null, 8, _hoisted_7)) : _unref(type) === 'video' ? (_openBlock(), _createBlock(VideoPreview, {
          key: 2,
          videoUrl: __props.fileInfo.fileUrl,
          height: "480px",
          width: "700px"
        }, null, 8, ["videoUrl"])) : (_openBlock(), _createElementBlock("iframe", {
          key: 3,
          onLoad: _cache[0] || (_cache[0] = $event => setIframeHeight()),
          id: "preview-iframe",
          name: "preview-iframe",
          src: `/aliyuncs/previewdoc/index.html?fileId=${__props.fileInfo.fileId}`,
          style: {
            "width": "700px",
            "height": "500px"
          }
        }, null, 40, _hoisted_8))])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};